module.exports = __webpack_public_path__ + "img/otp_example.82ec287d.png";